import YoutubePlayerController from './YoutubePlayerController';
import loadScript from '../../../utils/load_script';
import { logDebugging } from '../../../log/logger';
import { isIphone } from '../../../utils/browserUtils';
import { getDomainFromUrl, getParentUrlOrigin } from '../../../utils/urlUtils';

export default class YoutubePlayerManager {
  constructor(videoData, config) {
    this.videoData = videoData;
    this.config = config;
  }

  async load(urlVideo) {
    await this.loadLibrary();
    return new Promise((resolve) => {
      setTimeout(() => {
        this.urlVideo = urlVideo;
        const playerYoutube = this.loadPlayer();
        this.controllerComponent = new YoutubePlayerController(playerYoutube);
        resolve(this.controllerComponent);
      }, 1000);
    });
  }

  async loadLibrary() {
    logDebugging('videoData.idVideoElement', this.videoData.idVideoElement);
    if (typeof YT === 'undefined') {
      await loadScript(process.env.URL_YOUTUBE_LIBRARY);
    }
  }

  loadPlayer() {
    const params = {};
    // eslint-disable-next-line no-undef
    const [origin] = document.location.ancestorOrigins || [getDomainFromUrl(getParentUrlOrigin())];
    params.origin = origin || 'http://';
    params.showinfo = 0;
    params.controls = this.config.showControls ? 1 : 0;
    params.autoplay = this.config.autoplay; // BrowserProperties.isMobile() ? 0 : this.autoPlay;
    params.playsinline = isIphone() ? 1 : 0;
    params.rel = 0;
    params.mute = this.config.muted || this.config.autoplay; // inicializamos el objeto en mute y después se activa el volumen o se deja en mute.
    // Lo hademos asi por el problema que hay en los navegadores de inicializar los videos en autoplay con sonido.

    params.iv_load_policy = 3;
    params.disablekb = 1;

    // eslint-disable-next-line no-undef
    const myPlayer = new YT.Player(this.videoData.idYoutubeElement, {
      height: '100%',
      width: '100%',
      videoId: this.videoData.url,
      controls: this.config.showControls ? 1 : 0,
      autohide: 0,
      playerVars: params,
      // events: {
      //   onReady: this.onPlayerReady.bind(this),
      //   onStateChange: this.onPlayerStateChange.bind(this),
      // },
    });

    return myPlayer;
  }

  // // eslint-disable-next-line class-methods-use-this
  // onPlayerReady(event) {
  //   // eslint-disable-next-line no-console
  //   console.log('onPlayerReady', event.target, this.config);
  // }

  // // eslint-disable-next-line class-methods-use-this
  // onPlayerStateChange(event) {
  //   // eslint-disable-next-line no-console
  //   console.log('onPlayerStateChange', event.target, this.config);
  // }

  getEvent() {
    return this.controllerComponent.getEvent();
  }
}
